import produce from 'immer';
import {
  POST_USER_PROFILE_DATA,
  ProfileTypes,
  profileState,
  POST_BUSINESS_PROFILE_DATA,
  DROP_PROFILE_DATA,
  POST_PLUGIN_DATA,
  POST_REPORT_DATA,
  POST_BUSINESS_ID,
} from './types';

const initialState: profileState = {
  userProfileData: {
    externalIds: {userId: null},
    id: null,
    image: null,
    name: null,
    role: null,
    mobileNumber: null,
    emailAddress: null,
    signature: null,
    address: null,
    businessId: null,
    country: null,
  },
  businessProfileData: {
    businessScope: null,
    businessType: null,
    companyName: null,
    companyNumber: null,
    brandDescription: null,
    industryType: null,
    subIndustryType: null,
    imageUri: null,
    location: [
      {
        locationNickname: null,
        locationType: null,
        PICAddress: null,
        renspa: null,
        address: null,
        postcode: null,
        town: null,
        state: null,
        LPAUserID: null,
        LPAPassword: null,
        NLISUserID: null,
        NLISPassword: null,
        geofence: null,
        country: null,
        locationId: null,
      },
    ],
  },
};

function profileReducer(
  state = initialState,
  action: ProfileTypes,
): profileState {
  switch (action.type) {
    case POST_USER_PROFILE_DATA:
      return produce(state, (draft) => {
        draft.userProfileData = action.payload;
      });
    case POST_BUSINESS_ID:
      return produce(state, (draft) => {
        draft.userProfileData.businessId = action.payload;
      });
    case POST_BUSINESS_PROFILE_DATA:
      return produce(state, (draft) => {
        draft.businessProfileData = action.payload;
      });
    case DROP_PROFILE_DATA:
      return initialState;
    case POST_PLUGIN_DATA:
      return produce(state, (draft) => {
        draft.plugins = action.payload;
      });
    case POST_REPORT_DATA:
      return produce(state, (draft) => {
        draft.reports = action.payload;
      });
    default:
      return state;
  }
}

export default profileReducer;
